import React, { useEffect, useState } from "react";
import PosterSlider from "../Home/PosterSlider";
import Tags from "../Home/Tags";
import { requestCanceller } from "../../service/axiosCancelToken";
import { getHomePageInfo } from "../../service/userService";
import LoadingBar from "../shared/EclipseLoading";
import socket from "../../service/socket";
import { Helmet } from "react-helmet";

const Home = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [posters, setPosters] = useState();
    const [groups, setGroups] = useState();

    useEffect(() => {
        const cancelRequest = requestCanceller();

        const fetchHomePageInfo = async () => {
            try {
                setIsLoading(true);
                let { status, data } = await getHomePageInfo({
                    signal: cancelRequest.signal,
                });
                if (status === 201) {
                    setPosters(data.posters);
                    setGroups(data.groups);
                    setIsLoading(false);
                }
            } catch (err) {}
        };
        fetchHomePageInfo();
        return () => {
            cancelRequest.cancel();
        };
    }, []);

    useEffect(() => {
        socket.on("group", (data) => {
            if (data.action === "create") {
                const prevGroups = [...groups];
                const findIndex = prevGroups.findIndex(
                    (item) => item._id === data.createdGroup._id,
                );
                if (findIndex <= -1) {
                    prevGroups.push(data.createdGroup);
                    setGroups(prevGroups);
                }
            } else if (data.action === "update") {
                const prevGroups = [...groups];
                const findIndex = prevGroups.findIndex(
                    (item) => item._id === data.updatedGroup._id,
                );
                if (findIndex > -1) {
                    prevGroups[findIndex] = data.updatedGroup;
                    setGroups(prevGroups);
                }
            } else if (data.action === "delete") {
                const prevGroups = [...groups];
                const newCategories = prevGroups.filter(
                    (item) => item._id !== data.groupId,
                );
                setGroups(newCategories);
            }
        });

        return () => {
            socket.off("group");
        };
    }, [groups]);

    useEffect(() => {
        socket.on("poster", (data) => {
            if (data.action === "create") {
                const prevPosters = [...posters];
                const findIndex = prevPosters.findIndex(
                    (item) => item._id === data.createdTemplate._id,
                );
                if (findIndex <= -1) {
                    prevPosters.push(data.createdTemplate);
                    setPosters(prevPosters);
                }
            } else if (data.action === "update") {
                const prevPosters = [...posters];
                const findIndex = prevPosters.findIndex(
                    (item) => item._id === data.updatedPoster._id,
                );
                if (findIndex > -1) {
                    prevPosters[findIndex] = data.updatedPoster;
                    setPosters(prevPosters);
                }
            } else if (data.action === "delete") {
                const prevPosters = [...posters];
                const newPosters = prevPosters.filter(
                    (item) => item._id !== data.posterId,
                );
                setPosters(newPosters);
            }
        });

        return () => {
            socket.off("poster");
        };
    }, [posters]);

    return (
        <div>
            <Helmet>
                <title>
                    {" "}
                     آلماتک | روستابازار زنجان | مواد غذایی | میوه و سبزیجات | آجیل و خشکبار | ادویه جات | شوینده و لوازم بهداشتی
                    | تره بار | کالاهای اساسی | محصولات ویژه | برنج روغن |
                    حبوبات | لبنیات
                </title>
                <meta
                    name="description"
                    content={`${"فروش انواع کالاهای اساسی | برنج | حبوبات | مواد غذایی | میوه و سبزیجات | تره بار | آجیل و خشکبار | شوینده و لوازم بهداشتی | لبنیات و ..."}`}
                />
            </Helmet>
            {!posters || !groups || isLoading ? (
                <section
                    style={{
                        height: "60vh",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <LoadingBar classNames={`ldio-text-danger`} />
                </section>
            ) : (
                <React.Fragment>
                    <section>
                        <PosterSlider posters={posters} />
                    </section>
                    <section>
                        {groups.map((group) => (
                            <Tags key={group._id} group={group} />
                        ))}
                    </section>
                </React.Fragment>
            )}
        </div>
    );
};

export default Home;
